import cx from 'classnames';
import React from 'react';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import { useRegistrZPContext } from '@gov-nx/module/page';
import { ServiceCode } from '@gov-nx/module/service';
import {
	Chip,
	CommaSpace,
	ContentLayout,
	ErrorStatusBanner,
	InfoBanner,
	TabsNav,
	Tile,
	Tiles,
} from '@gov-nx/ui/web';
import { serviceRouteResolver } from '@gov-nx/web';
import { RegisterZPSkeleton } from './RegisterZPSkeleton';

export const RegisterZPView = () => {
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const { code, badges, setActiveBadge, subjects, controls } =
		useRegistrZPContext();

	const tsn = getLocalizeCurried(code);

	if (controls.initialLoading) {
		return <RegisterZPSkeleton />;
	}

	if (controls.initialError) {
		return <ErrorStatusBanner code={code} />;
	}

	return (
		<ContentLayout customClasses="pt-4!">
			<TabsNav aria-label={tsn('filtr.stav-subjektu')}>
				{badges.map((badge, index) => (
					<li
						key={badge.nameCode}
						className="gov-tabs__item">
						<button
							role="tab"
							className={cx('gov-tabs__btn', badge.isActive ? 'selected' : '')}
							aria-selected={badge.isActive}
							aria-label={`${tsn('filtr.zobrazit-subjekty-ve-stavu')}: ${tsn(
								badge.nameCode
							)}`}
							onClick={() => setActiveBadge(index)}>
							{tsn(badge.nameCode)}
						</button>
					</li>
				))}
			</TabsNav>
			{subjects.length ? (
				<Tiles>
					{subjects.map((subject) => (
						<Tile
							key={subject.ic}
							name={subject.name}
							target="_blank"
							to={`https://www.rzp.cz/cgi-bin/portal.cgi?ICO=${subject.ic}`}
							headlineLink
							iconLink
							icon={{ name: 'box-arrow-up-right', type: 'components' }}>
							{subject.status && subject.status !== 'OK' ? (
								<Chip
									color="neutral"
									size="s">
									{subject.status}
								</Chip>
							) : null}
							<div className="flex flex-col gap-(--spacing-m-nudge)">
								<p className="text-(--text-secondary)!">
									{tsn('subjekt.ic')}: <strong>{subject.ic}</strong>
									<CommaSpace />
									{tsn('subjekt.role')}: <strong>{subject.roles}</strong>
								</p>
								<p>
									<a
										href={serviceRouteResolver(
											ServiceCode['neverejny-vypis-z-ZR']
										)}>
										{tsn('subjekt.vypis-subjektu')}
									</a>
								</p>
							</div>
						</Tile>
					))}
				</Tiles>
			) : (
				<InfoBanner
					headline={
						badges[0].isActive
							? tsn('data.error.zadny-aktivni-zaznam')
							: tsn('data.error.zadny-neaktivni-zaznam')
					}
					text={
						badges[0].isActive
							? tsn('data.error.popis-aktivni')
							: tsn('data.error.popis-neaktivni')
					}
				/>
			)}
		</ContentLayout>
	);
};
